/* lp-quiz.js — shared Find Your Shade lightbox (LP §3.12 / §13). Idempotent. */
/* =============================================================================
   Find Your Shade quiz — LP framework (guide §13.3).
   Emits `bbe:shade-quiz:select` { shade, tier, title }.
============================================================================= */
(function () {
  'use strict';

  function quizWinnerFromTally(T) {
    var keys = ['light', 'medium', 'dark'];
    keys.sort(function (a, b) {
      if (T[b] !== T[a]) return T[b] - T[a];
      var pref = { medium: 0, light: 1, dark: 2 };
      return pref[a] - pref[b];
    });
    return keys[0];
  }

  function clampQuizWinnerToCeiling(rawWinner, ceilingRaw) {
    var c = String(ceilingRaw || '').trim().toLowerCase();
    var w = String(rawWinner || '').trim().toLowerCase();
    if (!w) return 'medium';
    if (c === 'medium' && w === 'dark') return 'medium';
    if (c === 'light' && (w === 'dark' || w === 'medium')) return 'light';
    return w;
  }

  function getFocusable(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function initShadeQuizLightboxForLb(lb) {
    if (!lb || lb.dataset.lpShadeQuizBound === '1') return;
    lb.dataset.lpShadeQuizBound = '1';

    var root = lb.closest('[data-shade-quiz-root]') || lb.parentElement || document;
    var sheet = lb.querySelector('.shade-quiz-lb__sheet');
    var backBtn = lb.querySelector('#lp-shade-quiz-lb-back');
    var closeX = lb.querySelector('#lp-shade-quiz-lb-x');
    var progFill = lb.querySelector('#lp-shade-quiz-lb-progress-fill');
    var progLabel = lb.querySelector('#lp-shade-quiz-lb-progress-label');
    var stepEls = lb.querySelectorAll('[data-lb-step]');

    var cfg = {};
    try {
      var cfgEl = (root.querySelector && root.querySelector('#lp-shade-quiz-config')) || document.getElementById('lp-shade-quiz-config');
      if (cfgEl && cfgEl.textContent) cfg = JSON.parse(cfgEl.textContent);
    } catch (e) { cfg = {}; }

    var fieldByStep = [null, 'sq_burn', 'sq_freckle', 'sq_tone', 'sq_eyes', 'sq_hair'];
    var FIRST_STEP = 1;
    var step = FIRST_STEP;
    var lastFocus = null;
    var suppressAutoAdvance = false;

    function applyResult() {
      var T = { light: 0, medium: 0, dark: 0 };
      ['sq_burn', 'sq_freckle', 'sq_tone', 'sq_eyes', 'sq_hair'].forEach(function (n) {
        var i = lb.querySelector('input[name="' + n + '"]:checked');
        if (i && T[i.value] !== undefined) T[i.value] += 1;
      });
      var winner = clampQuizWinnerToCeiling(quizWinnerFromTally(T), cfg.quizShadeCeiling);
      var pool = (cfg.variants || []).filter(function (x) { return x.tier === winner; });
      var v = pool.find(function (x) { return x.img; }) || pool[0];
      var res = cfg.results && cfg.results[winner];
      var schemaHero = res && res.hero_image;
      var optionHero = cfg.option_images && cfg.option_images[winner];
      var heroUrl =
        (schemaHero && String(schemaHero).trim() !== '' && schemaHero) ||
        (v && v.img && String(v.img).trim() !== '' && v.img) ||
        (optionHero && String(optionHero).trim() !== '' && optionHero) ||
        '';

      var titleEl = lb.querySelector('#lp-shade-quiz-result-title');
      var img = lb.querySelector('#lp-shade-quiz-result-img');
      var imgWrap = lb.querySelector('#lp-shade-quiz-result-img-wrap');
      var copyEl = lb.querySelector('#lp-shade-quiz-result-copy');
      if (titleEl) titleEl.textContent = (v && v.title) || winner;
      if (img) {
        if (heroUrl) { img.src = heroUrl; img.alt = (v && v.title) || ''; img.hidden = false; if (imgWrap) imgWrap.hidden = false; }
        else { img.removeAttribute('src'); img.hidden = true; if (imgWrap) imgWrap.hidden = true; }
      }
      if (copyEl) copyEl.innerHTML = (res && res.copy) || '';

      var ba = (cfg.ba && cfg.ba[winner]) || {};
      var bb = lb.querySelector('#lp-shade-quiz-ba-before');
      var baft = lb.querySelector('#lp-shade-quiz-ba-after');
      var baBox = lb.querySelector('#lp-shade-quiz-result-ba');
      if (bb) { if (ba.before) { bb.src = ba.before; bb.closest('figure').style.display = ''; } else { bb.removeAttribute('src'); bb.closest('figure').style.display = 'none'; } }
      if (baft) { if (ba.after) { baft.src = ba.after; baft.closest('figure').style.display = ''; } else { baft.removeAttribute('src'); baft.closest('figure').style.display = 'none'; } }
      if (baBox) baBox.style.display = (ba.before || ba.after) ? 'grid' : 'none';

      if (v && v.shade) {
        var detail = { shade: v.shade, tier: winner, title: v.title || winner };
        document.dispatchEvent(new CustomEvent('bbe:shade-quiz:select', { detail: detail, bubbles: true }));
        if (window.BBEShadeQuiz && typeof window.BBEShadeQuiz.onSelect === 'function') {
          try { window.BBEShadeQuiz.onSelect(detail); } catch (e) {}
        }
      }
    }

    function setProgress() {
      if (progFill) {
        var pct = (step >= 1 && step <= 5) ? Math.round((step / 6) * 100) : (step === 6 ? 100 : 0);
        progFill.style.width = pct + '%';
      }
      if (!progLabel) return;
      if (step >= 1 && step <= 5) progLabel.textContent = 'Question ' + step + ' of 5';
      else progLabel.textContent = '';
    }

    function setStep(n) {
      step = n;
      if (sheet) {
        sheet.scrollTop = 0;
        sheet.classList.toggle('shade-quiz-lb__sheet--result', step === 6);
      }
      stepEls.forEach(function (el) {
        var on = parseInt(el.getAttribute('data-lb-step'), 10) === step;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
      if (backBtn) backBtn.hidden = step <= FIRST_STEP || step === 6;
      setProgress();
      if (step === 6) {
        var resEl = lb.querySelector('[data-lb-step="6"]');
        if (resEl && typeof resEl.focus === 'function') {
          try { resEl.focus({ preventScroll: true }); } catch (err) { resEl.focus(); }
        }
      }
    }

    function resetQuiz() {
      suppressAutoAdvance = true;
      lb.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
      step = FIRST_STEP;
      setStep(FIRST_STEP);
      suppressAutoAdvance = false;
    }

    function validateCurrent() {
      if (step === 6) return true;
      var name = fieldByStep[step];
      if (!name) return true;
      return !!lb.querySelector('input[name="' + name + '"]:checked');
    }

    function advanceAfterAnswerIfCurrent() {
      if (suppressAutoAdvance || lb.hidden) return;
      if (step < FIRST_STEP || step > 5) return;
      if (!validateCurrent()) return;
      if (step === 5) { applyResult(); setStep(6); return; }
      setStep(step + 1);
    }

    function openLb() {
      lastFocus = document.activeElement;
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lp-shade-quiz-lb-open');
      resetQuiz();
      if (closeX) closeX.focus();
    }
    lb.__lpOpenShadeQuiz = openLb;

    function closeLb() {
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lp-shade-quiz-lb-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    lb.querySelectorAll('[data-shade-quiz-lb-close]').forEach(function (el) { el.addEventListener('click', closeLb); });
    if (closeX) closeX.addEventListener('click', closeLb);
    if (backBtn) backBtn.addEventListener('click', function () { if (step > FIRST_STEP) setStep(step - 1); });

    lb.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('.shade-quiz-lb__opt') : null;
      if (!opt || !lb.contains(opt) || suppressAutoAdvance) return;
      if (step < FIRST_STEP || step > 5) return;
      var radio = opt.querySelector('input[type="radio"]');
      if (!radio || radio.name !== fieldByStep[step]) return;
      if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); return; }
      advanceAfterAnswerIfCurrent();
    });

    lb.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !lb.contains(t) || suppressAutoAdvance) return;
      if (step < FIRST_STEP || step > 5) return;
      if (t.name !== fieldByStep[step]) return;
      advanceAfterAnswerIfCurrent();
    });

    var retryBtn = lb.querySelector('.js-shade-quiz-retry');
    if (retryBtn) retryBtn.addEventListener('click', resetQuiz);

    lb.addEventListener('click', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('.js-shade-quiz-select-shade') : null;
      if (!sel || !lb.contains(sel) || step !== 6) return;
      e.preventDefault();
      applyResult();
      closeLb();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeLb(); return; }
      if (e.key === 'Tab' && sheet) {
        var f = getFocusable(sheet);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!sheet.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }
    });
  }

  var openBound = false;
  function bindOpenOnce() {
    if (openBound) return;
    openBound = true;
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('.js-shade-quiz-open');
      if (!opener) return;
      var mod = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
      var fb = (opener.getAttribute('data-shade-quiz-fallback-url') || '').trim();
      var scope = opener.closest('[data-shade-quiz-root]') || document;
      var lbEl = scope.querySelector('#lp-shade-quiz-lb') || document.getElementById('lp-shade-quiz-lb');
      if (lbEl && typeof lbEl.__lpOpenShadeQuiz === 'function') {
        if (mod) { if (fb) { e.preventDefault(); window.open(fb, '_blank', 'noopener,noreferrer'); } return; }
        e.preventDefault();
        lbEl.__lpOpenShadeQuiz();
        return;
      }
      if (!mod && fb) { e.preventDefault(); window.location.assign(fb); }
    }, true);
  }

  function init() {
    bindOpenOnce();
    document.querySelectorAll('#lp-shade-quiz-lb').forEach(initShadeQuizLightboxForLb);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

